/*global angular */
/*jslint node: true */
'use strict';


var tutor = angular.module('msTutor', []);

tutor.service('msTutor', ['$compile', '$templateCache', '$rootScope', 'msUser', function ($compile, $templateCache, $rootScope, msUser) {
    /** @type {[msTutorial]} */
    var tutorials = [];

    var msTutor = {
        hidden: true,
        _errorMessage: null,

        /** @return {[msTutorial]} */
        getTutorials: function () {
            return tutorials;
        },

        /** @param {msTutorial|*} tutorial */
        addTutorial: function (tutorial) {
            tutorials.push(tutorial);
        },

        showError: function (message) {
            msTutor._errorMessage = message;
        },

        /**
         * load tutorial by key
         *
         * @param key {string} - tutorial key
         * @param [startStep=0] {number} - the step to start default = 0
         */
        loadTutorial: function (key, startStep) {
            /** @type {msTutorialStep} */
            var step = null;
            /** @type {msTutorial} */
            var tut = null;

            msTutor.hidden = false;

            msTutor._undo_changes();

            // stop current tutorial step
            if (msTutor.steps.length) {
                step = msTutor.steps[msTutor.currentStep];
                if (step.stop) step.stop(step);
            }

            // search tutorial by key
            tutorials.forEach(function (tutorial) {
                if (tutorial.key == key) {
                    tut = tutorial;
                }
            });
            if (!tut) return;

            // set tutorial informations
            msTutor.tutorial = tut;
            msTutor.steps = tut.steps;
            msTutor.currentStep = startStep | 0;
            // init tutorial
            step = msTutor.steps[msTutor.currentStep];
            if (step.start) step.start(step);
        },

        currentStep: 0, // the current step position .steps[currentStep]
        /** @type {[msTutorialStep]} */
        steps: [], // contains the step list of the current tutorial
        /** @type {msTutorial} */
        tutorial: null, // the  current tutorial

        _changes: [],
        _undo_changes: function () {
            msTutor._errorMessage = null;
            msTutor._changes.reverse().forEach(function (obj) {
                if (obj.type == 'stepChangeElementStyle') {
                    if (obj.element.style[obj.property] == obj.new_value) {
                        obj.element.style[obj.property] = obj.backup_value;
                        obj.element = null;
                    }
                } else if (obj.type == 'stepOnEvent') {
                    obj.destructor();
                    obj.destructor = null;
                } else if (obj.type == 'stepAddClass') {
                    angular.element(obj.element).removeClass(obj.className);
                    obj.element = null;
                } else if (obj.type == 'stepCallOnLeave') {
                    obj.callback();
                    obj.callback = null;
                } else if (obj.type == 'stepRemoveClass') {
                    angular.element(obj.element).addClass(obj.className);
                    obj.element = null;

                } else {
                    // todo: log console.log("msTutor._undo_changes() error unknow type:", obj.type);
                }
            });
            msTutor._changes = [];
        },

        /**
         * use this helper to change style properties.
         * example: msTutor.stepChangeElementStyle(document.getElementById('some-id'), 'background-color', '#red')
         * @param element {HTMLElement}
         * @param style_property {String}
         * @param new_value {String|number|*}
         */
        stepChangeElementStyle: function (element, style_property, new_value) {
            var obj = {
                type: 'stepChangeElementStyle',
                element: element,
                property: style_property,
                new_value: new_value,
                backup_value: element.style[style_property]
            };
            element.style[style_property] = new_value;
            msTutor._changes.push(obj);
        },

        stepOnEvent: function (eventName, callback) {
            var obj = {
                type: 'stepOnEvent',
                destructor: $rootScope.$on(eventName, callback)
            };
            msTutor._changes.push(obj);
        },

        /**
         * @param element {HTMLElement}
         * @param className {String}
         */
        stepAddClass: function (element, className) {
            var obj = {
                type: 'stepAddClass',
                element: element,
                className: className
            };
            angular.element(element).addClass(className);
            msTutor._changes.push(obj);
        },

        /**
         * @param element {HTMLElement}
         * @param className {String}
         */
        stepRemoveClass: function (element, className) {
            var obj = {
                type: 'stepRemoveClass',
                element: element,
                className: className
            };
            angular.element(element).removeClass(className);
            msTutor._changes.push(obj);
        },

        stepCallOnLeave: function (callback) {
            if (!callback) return; // callback
            var obj = {
                type: 'stepCallOnLeave',
                callback: callback
            };
            msTutor._changes.push(obj);
        },

        nextStep: function () {
            if (msTutor.currentStep == msTutor.steps.length - 1) return;
            msTutor._undo_changes();
            var step = msTutor.steps[msTutor.currentStep];
            if (step.stop) step.stop(step);
            msTutor.currentStep += 1;
            step = msTutor.steps[msTutor.currentStep];
            if (step.start) step.start(step);
        },

        prevStep: function () {
            if (msTutor.currentStep === 0) return;
            msTutor._undo_changes();
            var step = msTutor.steps[msTutor.currentStep];
            if (step.stop) step.stop(step);
            msTutor.currentStep -= 1;
            step = msTutor.steps[msTutor.currentStep];
            if (step.start) step.start(step);
        },

        stop: function () {
            msTutor._undo_changes();
            // stop current tutorial step
            if (msTutor.steps.length) {
                var step = msTutor.steps[msTutor.currentStep];
                if (step.stop) step.stop(step);
            }
            msTutor.hidden = true;
        },

        done: function () {
            $rootScope.$evalAsync('user_settings.msTutor.' + msTutor.tutorial.key + '.done = true');
            msTutor.stop();
        },

        // extension configuration
        init: function (scope) {
            if (!scope.mode.edit) return;

            scope.msTutor = msTutor;
            var linkFn = $compile($templateCache.get('lib/msTutor/msTutor.html'));
            var content = linkFn(scope);
            angular.element(document.body).append(content);
            scope.$on('$destroy', function () {
                content.remove();
            });
            $rootScope.$on('msExtFinished', function () {
                return;
                var found = null;
                msTutor.getTutorials().forEach(function (tut) {
                    if (!found && !$rootScope.$eval('user_settings.msTutor.' + tut.key + '.done')) {
                        found = tut;
                    }
                });
                if (found) {
                    msTutor.loadTutorial(found.key);
                }
            });
        }
    };
    $rootScope.msTutor = msTutor;
    return msTutor;
}]);
